import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Card, BlockHeader } from '@teko/ui';
import { ActivatedFilters } from './components/ActivatedFilters.es.js';
import { FilterRow } from './components/FilterRow.es.js';
import { AdvancedFilterRow } from './components/AdvancedFilterRow.es.js';

const ListFilters = styled.div`
  padding: 1rem;
`;
const StyledCard = styled(Card)`
  width: 100%;
  overflow: unset;
`;
const Filter = ({
  filters,
  onClickOption,
  query,
  activeFilters = [],
  clearFilterLink
}) => /* @__PURE__ */ React.createElement(StyledCard, null, /* @__PURE__ */ React.createElement(BlockHeader, {
  content: /* @__PURE__ */ React.createElement(ActivatedFilters, {
    onClick: onClickOption,
    activeValues: activeFilters
  }),
  title: t("B\u1ED9 l\u1ECDc"),
  actionLink: activeFilters.length && {
    href: clearFilterLink || "#",
    title: t("X\xF3a b\u1ED9 l\u1ECDc"),
    color: "#ef2741",
    hideIcon: true,
    regionName: "headerFilter",
    contentName: "resetFilter"
  } || void 0
}), /* @__PURE__ */ React.createElement(ListFilters, null, filters.slice(0, 5).map((filter, index) => {
  const value = () => {
    var _a;
    return query[filter.code] || ((_a = query.dynamicFields) == null ? void 0 : _a[filter.code]);
  };
  return /* @__PURE__ */ React.createElement(FilterRow, {
    value: value(),
    onClickOption,
    key: index,
    filter
  });
}), filters.length > 5 && /* @__PURE__ */ React.createElement(AdvancedFilterRow, {
  activeValues: activeFilters,
  onClickOption,
  filters
})));

export { Filter };
